"use client"

import { useQuery } from '@tanstack/react-query';
import { NuisibleService } from '../../../lib/api/services/nuisible.service';

export interface UseSelectNuisiblesParams {
  search?: string;
  limit?: number;
  page?: number;
}

const nuisibleService = new NuisibleService();

export function useSelectNuisibles(params: UseSelectNuisiblesParams = {}) {
  return useQuery({
    queryKey: ['nuisibles-select', params],
    queryFn: () => nuisibleService.selectNuisibles(params as any),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}